<template lang="pug">
#anti_static
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_anti_static.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_anti_static_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 抗靜電包裝
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。
  section#product_profile
    b-row.menu
      b-col.text-center.active APET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品具有優良的抗靜電性，抗靜電添加劑有內部添加及表面處理兩種，可適用為一般電子包裝或工業包裝材料(如：五金、工具、電子零件、電子成品、手機及PDA等)			
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span  APET 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_3
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
              li 
                span(v-html="item.impedance")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'APET抗靜電包裝-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'APET抗靜電膠布具有優良的抗靜電性，抗靜電添加劑有內部添加及表面處理兩種，可適用為電子包裝、工業包裝、Tray。產品有導電級、抗靜電級、靜電消散級等。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、APET、導電、抗靜電、靜電消散。' },
            { name: 'og:title', content: 'APET抗靜電包裝-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'APET抗靜電膠布具有優良的抗靜電性，抗靜電添加劑有內部添加及表面處理兩種，可適用為電子包裝、工業包裝、Tray。產品有導電級、抗靜電級、靜電消散級等。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: '抗靜電電子包裝',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/anti_static_img_01.jpg',
            img_alt: '南亞APET有導電級、抗靜電級、靜電消散級等產品，可適用為電子包裝、工業包裝、Tray。' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/anti_static_img_02.jpg',
            img_alt: '南亞APET有導電級、抗靜電級、靜電消散級等產品，可適用為電子包裝、工業包裝、Tray。' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/anti_static_img_03.jpg',
            img_alt: '南亞APET有導電級、抗靜電級、靜電消散級等產品，可適用為電子包裝、工業包裝、Tray。' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: '抗靜電效果佳。' }
        ],
        a_use: [
          { message: '可客製化項目：爽身、電暈、耐寒、抗靜電、防霧及高週波等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、ASTM D-1003、ASTM D-523及ASTM D-257等。' }
        ],
        a_specification: [
          { 
            id: '1',
            name: '導電用AVVC',
            feature: '特色: 抗靜電效果良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.78 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">120～150</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦5.0</span>',
            impedance: '表面阻抗<sub>（Ω/□）</sub>：<br/><span class="pl-5">10<sup>4</sup> ~ 10<sup>6</sup></span>'},
          { 
            id: '2',
            name: '抗靜電成型用AVVE',
            feature: '特色: 抗靜電效果良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.78 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">150～165</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦4.0</span>',
            impedance: '表面阻抗<sub>（Ω/□）</sub>：<br/><span class="pl-5">分內部添加與外部處理</span>'},
          { 
            id: '3',
            name: '靜電消散用AVVH',
            feature: '特色: 抗靜電效果良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.65 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">120～150</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦4.5</span>',
            impedance: '表面阻抗<sub>（Ω/□）</sub>：<br/><span class="pl-5">10<sup>6</sup> ~ 10<sup>8</sup></span>'}
        ],
        swiperOption_apet: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'食藥醫療',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'3',
            name:'建材裝潢',
            text:'在連續基材上，經過印刷、塗佈、貼合或壓製等工藝而製成的產品。 複合塑膠建材裝璜產品是由多層結構熱壓而成..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'卡片貼合',
            text:'本製品可經印刷、貼合、衝卡、打碼、分卡質檢等工序製成各種卡片。',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'事務文具',
            text:'本製品可經印刷、貼合、沖裁或熔著等工序製成各種事務文具用產品。',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'水處理',
            text:'本製品之加工方式有軋壓及成型兩種。客戶若使用成型方式加工，則須特別管制成型性。',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green APET',
            text:'PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET膠布',
            text:'C-PET膠布需經由壓空成型機模具加熱成型使其結晶，成型品可耐高溫。',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#anti_static
  #specification
    background-image: url(../assets/bg/bg_anti_static.jpg)

</style>
